import { Chip } from "@mui/material";
import { useMemo } from "react";

import { TRANSACTION_STATUS } from "../../../models/Customer";
import { supportive } from "../../../theme/colors";

export const StatusChip = (label: string) => {
  const backgroundColor = useMemo(() => {
    switch (label) {
      case TRANSACTION_STATUS.COMPLETED:
        return "#82D89E";
      case TRANSACTION_STATUS.PENDING:
        return "#FFE378";
      case TRANSACTION_STATUS.FAILED:
        return supportive.red;
      default:
        return "transparent";
    }
  }, [label]);

  return <Chip label={label} style={style(backgroundColor).chip} />;
};

const style = (backgroundColor: string) => ({
  chip: {
    fontWeight: 800,
    backgroundColor: backgroundColor,
    borderRadius: 8,
  },
});
